(()=>{
  const init=root=>{
    if(root.dataset.training73Ready)return;
    root.dataset.training73Ready='true';
    const rail=root.querySelector('.training73-rail');
    const controls=root.querySelector('.training73-controls');
    const prev=root.querySelector('[data-training73-prev]');
    const next=root.querySelector('[data-training73-next]');
    if(!rail||!controls||!prev||!next)return;
    const sync=()=>{const max=rail.scrollWidth-rail.clientWidth;controls.hidden=max<4;prev.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft>=max-4;};
    const move=direction=>rail.scrollBy({left:direction*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',sync,{passive:true});
    const observer=new ResizeObserver(sync);observer.observe(rail);sync();
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root))observer.disconnect();},{once:true});
  };
  document.querySelectorAll('.training73').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.training73').forEach(init));
})();
